'use client';
import Link from 'next/link';

import Card, { CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';

import { DATA_CY_CONTACT_US_CARD } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

import ContactUsForm from './contactUsForm';
import Units from './units';

export default function ContactUsCard() {
  const {
    content: { contact: contactLocalization },
  } = pageLevelLocalization;

  return (
    <Card data-cy={DATA_CY_CONTACT_US_CARD} className='rounded-xl bg-white pb-4' noBorder>
      <CardContent className='relative grid gap-8 pt-8 pr-4 md:pr-6'>
        <Container className='flex flex-row items-center gap-5'>
          <Container className='relative max-h-14 min-h-14 max-w-12 min-w-12'>
            <XImage
              src={imagesList.backgrounds.zhaketLogoBG}
              alt='location'
              width={48}
              height={58}
            />
            <XImage
              src={imagesList.icons.zhaketOrangeLogo}
              alt='location'
              className='absolute top-0 right-0 bottom-0 left-0 m-auto'
            />
          </Container>
          <Container>
            <Heading
              type={HEADING_TYPE.H2}
              className='text-lg leading-8 font-medium tracking-tighter text-[#424244]'
            >
              {contactLocalization.phone_communication_with_zhaket}
            </Heading>
            <Text
              type={TEXT_TYPE.P}
              className='text-right text-[13px] leading-6 font-light tracking-tighter text-[#76767C]'
            >
              {contactLocalization.note_contact_us_first_part}
              <Link
                prefetch={false}
                href='/panel/tickets/new'
                className='inline-flex items-center text-[#6097F3]'
              >
                &nbsp;
                <XImage
                  className='px-[1px]'
                  src={imagesList.icons.pannelTicketIcon}
                  alt={contactLocalization.pannel_ticket}
                />
                &nbsp;
                {contactLocalization.pannel_ticket}
                &nbsp;
              </Link>

              {contactLocalization.note_contact_us_second_part}
            </Text>
          </Container>
        </Container>
        <Units />
        <Container className='h-[1px] w-full bg-[#EAEAED]' />
        <ContactUsForm />
      </CardContent>
    </Card>
  );
}
